module.exports = __webpack_public_path__ + "static/d3Res1-8df904f0c6f233e4c55e1bddc78e29b2.png";